export const requisiteFontFamilyValues = {
  dancingScript: 'Dancing Script',
  sacramento: 'Sacramento',
  laBelleAurore: 'La Belle Aurore',
  bilboSwashCaps: 'Bilbo Swash Caps',
  yellowtail: 'Yellowtail',
  greatVibes: 'Great Vibes',
  qwigley: 'Qwigley',
  marckScript: 'Marck Script',
};

export const fontFamilyByValue = {
  arial: 'Arial',
  calibri: 'Calibri',
  cambria: 'Cambria',
  courier: 'Courier',
  georgia: 'Georgia',
  timesNewRoman: 'Times New Roman',
  trebuchet: 'Trebuchet',
  verdana: 'Verdana',
  openSans: 'Open Sans',
  roboto: 'Roboto',
  kalam: 'Kalam',
  gochiHand: 'Gochi Hand',
  caveat: 'Caveat',
  handlee: 'Handlee',
  nothingYouCouldDo: 'Nothing You Could Do',
  coveredByYourGrace: 'Covered By Your Grace',
  justAnotherHand: 'Just Another Hand',
  shadowsIntoLight: 'Shadows Into Light',
  badScript: 'Bad Script',
  stalemate: 'Stalemate',
  ...requisiteFontFamilyValues,
};

function mapValueAndLabel<K extends PropertyKey, V>(object: Record<K, V>) {
  return Object.entries(object).map(([key, value]) => ({
    value: key as K,
    label: value as V,
  }));
}

export const requisiteFontFamilyOptions = mapValueAndLabel(requisiteFontFamilyValues);
export const fontFamilyOptions = mapValueAndLabel(fontFamilyByValue);

const fontSizeValues = [7, 8, 9, 10, 12, 14, 16, 18, 20, 24, 26, 28, 36, 42, 48];

export const fontSizeOptions = fontSizeValues.map(fontSize => ({
  value: fontSize,
  label: `${fontSize} px`,
}));

export const interactInitialFont = { fontSize: 14, fontFamily: 'arial' } as const;

export const interactFieldInitialFont = {
  ...interactInitialFont,
  fontFamily: fontFamilyByValue[interactInitialFont.fontFamily],
} as const;
